<div class="container">
  <h3 mat-dialog-title>Uwaga</h3>
  <p class="conf-dialog-caption">{{ data.text }}</p>
  <div *ngIf="data.canClose" mat-dialog-actions>
    <button mat-button [mat-dialog-close]="1" (click)="confirm()">Zakmnij</button>
  </div>
</div>
  
<style>
  .conf-dialog-caption {
    font-size: 13px;
  }
</style>